import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { api, resolveImage } from "@/lib/api";

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.6, ease: "easeOut" },
};

export default function CategoriesSection() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    api.get("/categories").then(({ data }) => setCategories(data)).catch(() => {});
  }, []);

  if (categories.length === 0) return null;

  return (
    <section data-testid="categories-section" className="mx-auto max-w-7xl px-4 pb-16 sm:px-8">
      <motion.div {...fadeUp} className="mb-10">
        <p className="eyebrow">Nos univers</p>
        <h2 className="mt-2 font-serif text-2xl font-medium tracking-tight text-bark sm:text-3xl lg:text-4xl">
          Explorez la ruche par univers
        </h2>
      </motion.div>
      <div className="grid gap-6 md:grid-cols-3">
        {categories.map((c, i) => (
          <motion.div key={c.category_id} {...fadeUp} transition={{ duration: 0.6, delay: i * 0.08 }}>
            <Link
              to={`/boutique?categorie=${c.category_id}`}
              data-testid={`category-card-${c.category_id}`}
              className="group relative block overflow-hidden rounded-2xl border border-amber-900/10 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
            >
              {c.image_url && (
                <img src={resolveImage(c.image_url)} alt={c.name} loading="lazy" className="aspect-[4/3] w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-beeswax/75 via-beeswax/15 to-transparent" />
              <div className="absolute bottom-0 w-full p-6">
                <h3 className="font-serif text-2xl font-semibold text-cream">{c.name}</h3>
                {c.description && <p className="mt-1 line-clamp-2 text-sm text-cream/75">{c.description}</p>}
                <span className="mt-3 inline-flex items-center gap-2 text-sm font-medium text-amber-glow transition-colors group-hover:text-white">
                  Découvrir <ArrowRight size={15} />
                </span>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
